import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { useCookieConsentStore } from '@/stores/cookie-consent-store';

/**
 * Small persistent affordance to reopen cookie preferences after the initial
 * decision. Needed because the site-wide footer (`CopyrightBar`) is currently
 * disabled, so this is the only reachable way to revisit consent.
 */
export function CookieSettingsLauncher({ className }: { className?: string }) {
  const { t } = useTranslation();
  const openPreferencesModal = useCookieConsentStore((s) => s.openPreferencesModal);

  return (
    <button
      type="button"
      onClick={openPreferencesModal}
      aria-label={t('cookieConsent.settingsButton')}
      title={t('cookieConsent.settingsButton')}
      className={cn(
        'fixed bottom-4 left-4 z-30 flex h-10 w-10 items-center justify-center rounded-full',
        'border border-barita-ink/10 bg-white text-barita-ink shadow-md transition-transform',
        'hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-barita-ink/40',
        className,
      )}
    >
      <svg
        className="h-5 w-5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        aria-hidden
      >
        <circle cx="12" cy="12" r="9" />
        <circle cx="9" cy="9.5" r="1" fill="currentColor" stroke="none" />
        <circle cx="14.5" cy="8.5" r="1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="13.5" r="1" fill="currentColor" stroke="none" />
        <circle cx="9.5" cy="14.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    </button>
  );
}
